module.exports = __webpack_public_path__ + "6ccf414fe456ab5b5ad554e337fd150e.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/eyes/uneven-29.png
// module id = 1712
// module chunks = 0